import React from 'react';

import { WidgetArticleTitleContent } from 'jamespot-user-api';
import { JRCButton } from 'components/JRCButton/JRCButton';
import { useIntl } from 'react-intl';
import {
    CSSEditor,
    CSSEditorComponentLabel,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';
import { EditorColorPicker } from 'components/Editors/components/EditorColorPicker';
import { EditorSelect } from 'components/Editors/components/EditorSelect';
import { EditorColorsOptions, EditorHeadingOptions } from '../const';
import { useTheme } from 'styled-components';

export function useFirstRender() {
    const firstRender = React.useRef(true);

    React.useEffect(() => {
        firstRender.current = false;
    }, []);

    return firstRender.current;
}

export const JRCWidgetArticleTitleEditor = ({
    content,
    onChange,
    onSave,
}: {
    content: WidgetArticleTitleContent;
    onOpen: (view: React.ReactElement) => void;
    onSave: (content: Partial<WidgetArticleTitleContent>) => void;
    onChange: (content: Partial<WidgetArticleTitleContent>, override?: boolean) => void;
}) => {
    const intl = useIntl();
    const theme = useTheme();
    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>{intl.formatMessage({ id: 'PANEL_Text_Color' })}</CSSEditorComponentLabel>
                    <EditorColorPicker
                        colors={EditorColorsOptions}
                        initialValue={content.color ?? theme.color.black}
                        onChange={(color) => onChange({ color })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <EditorSelect
                        label={intl.formatMessage({ id: 'PANEL_Heading' })}
                        options={EditorHeadingOptions}
                        initialValue={content.heading}
                        onChange={(heading) => onChange({ heading })}
                    />
                </CSSEditorComponentWrapper>
            </CSSEditorWidgetProperties>
            <JRCButton onClick={() => onSave(content)} variant={'outlined'} minWidth={'100%'}>
                {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
            </JRCButton>
        </CSSEditor>
    );
};
